module.exports = __webpack_public_path__ + "media/andenes/minidock_elemax-01d81abb.webp";